module.exports = __webpack_public_path__ + "img/advantages-front-small.04fb08b5.png";